import { Box, Skeleton } from '@mui/material';

/** Loading placeholder for the output panel (metric grid + tabs + content). */
export const PlanSkeleton = () => (
  <Box>
    {/* Metric grid */}
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: 'repeat(2, 1fr)', md: 'repeat(4, minmax(0, 1fr))' },
        gap: 1.5,
        mb: 3,
      }}
    >
      {Array.from({ length: 8 }).map((_, i) => (
        <Box
          key={i}
          sx={{
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: 1.5,
            p: 1.75,
          }}
        >
          <Skeleton variant="text" width="70%" height={14} />
          <Skeleton variant="text" width="45%" height={28} sx={{ my: 0.5 }} />
          <Skeleton variant="text" width="55%" height={12} />
        </Box>
      ))}
    </Box>

    {/* Tab bar */}
    <Box sx={{ display: 'flex', gap: 2, borderBottom: '2px solid', borderColor: 'divider', mb: 2.5, pb: 1 }}>
      {Array.from({ length: 4 }).map((_, i) => (
        <Skeleton key={i} variant="text" width={90} height={24} />
      ))}
    </Box>

    {/* Content rows */}
    <Skeleton variant="rounded" height={44} sx={{ mb: 1 }} />
    {Array.from({ length: 6 }).map((_, i) => (
      <Skeleton key={i} variant="rounded" height={38} sx={{ mb: 0.75 }} />
    ))}
  </Box>
);

/** Skeleton placeholders for the topbar badges. */
export const BadgeSkeletons = () => (
  <>
    {Array.from({ length: 4 }).map((_, i) => (
      <Skeleton key={i} variant="rounded" width={120} height={24} sx={{ borderRadius: 5 }} />
    ))}
  </>
);
